<template>
  <div>
    <div class="input-group-append h-100">
      <input
        autocomplete="off"
        name="search"
        v-model="searchText"
        type="text"
        @focus="onFocus"
        @input="autoComplete"
        @blur="closeSuggestions"
        class="form-control h-100"
        placeholder="Search Address Here (e.g. 446 Rigel Avenue, Erasmusrand)"
      >
      <div class="input-group-append">
        <input
          @click="search"
          type="submit"
          class="btn btn-primary h-100"
          value="Search"
        >
      </div>
    </div>
    <ul class="list-group">
      <li
        @mousedown="suggestionFocus = true"
        v-for="suggestion in suggestions"
        :key="suggestion.seoid"
        @click="chosen(suggestion)"
        class="list-group-item"
      >
        {{ suggestion.description }}
      </li>
    </ul>
  </div>
</template>

<script>
import { createAwsAxiosInstance, addressDetails, addressSearch } from '@afrigis/aws-search-services';
import EventBus from '@/eventBus';

export default {
  data() {
    return {
      axiosInstance: null,
      searchText: '',
      suggestionFocus: false,
      suggestions: null,
      token: null,
    };
  },
  methods: {
    autoComplete() {
      if (this.searchText.length < 3) {
        return;
      }
      this.suggestions = null;
      setTimeout(() => {
        const axiosInstance = this.getAxiosInstance();

        axiosInstance.get(`https://afrigis.services/places-autocomplete/api/v3/autocomplete?query=
        ${encodeURIComponent(this.searchText)}`,
        {
          headers: {
            Authorization: `Bearer ${this.token}`,
            'x-api-key': `${process.env.VUE_APP_AWS_KEY}`,
          },
        }).then((result) => {
          this.suggestions = result.data.result;
        });
      }, 200);
    },
    chosen(suggestion) {
      this.searchText = suggestion.description;
      this.suggestions = null;
      this.getSearchResults(suggestion);
    },
    closeSuggestions() {
      if (!this.suggestionFocus) {
        this.suggestions = null;
      }
    },
    getAxiosInstance() {
      if (!this.token) {
        this.tryGetToken();
      }
      return createAwsAxiosInstance(`${this.token}`, `${process.env.VUE_APP_AWS_KEY}`);
    },
    async getSearchResults(val) {
      const axiosInstance = this.getAxiosInstance();
      await addressDetails(axiosInstance, `${val.seoid}`)
        .then((response) => {
          const { data: { result } } = response;
          const clone = val;
          const coordinate = {
            latitude: result.location.lat,
            longitude: result.location.lng,
          };
          clone.latitude = coordinate.latitude;
          clone.longitude = coordinate.longitude;
          clone.viewport = [coordinate, coordinate];
          EventBus.$emit('coordinateSet', clone);
        });
    },
    onFocus() {
      this.suggestionFocus = false;
      this.tryGetToken();
    },
    async search() {
      if (this.searchText.length < 3) {
        return;
      }
      this.suggestions = null;
      const axiosInstance = this.getAxiosInstance();
      await addressSearch(axiosInstance, this.searchText)
        .then((response) => {
          this.suggestions = response.data.result.map((r) => ({
            seoid: r.seoid,
            description: r.formatted_address,
            centroid: {
              latitude: r.location.lat,
              longitude: r.location.lng,
            },
            viewport: [{
              latitude: r.location.lat,
              longitude: r.location.lng,
            }, {
              latitude: r.location.lat,
              longitude: r.location.lng,
            }],
          }));
        });
    },
    tryGetToken() {
      if (this.token) {
        return;
      }
      this.$http.get(`${process.env.VUE_APP_ROOT_API}/api/awsauthentication`).then((result) => {
        if (this.refreshTokenTimeoutFunction) {
          clearTimeout(this.refreshTokenTimeoutFunction);
          this.refreshTokenTimeoutFunction = null;
        }
        this.token = result.body.result.access_token;
        this.refreshTokenTimeoutFunction = setTimeout(() => {
          this.token = null;
          this.tryGetToken();
        }, 300000);
      });
    },
  },
  name: 'Autocomplete',
};
</script>

<style scoped>
input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-style: italic;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  font-style: italic;
}

::-ms-input-placeholder { /* Microsoft Edge */
  font-style: italic;
}
</style>
